import { ConfigurableProduct } from '@magentoTypes'

export const availableForms = (product: ConfigurableProduct) => {
  if (!product) return
  const related = product?.related_products
    ?.map((related) => related?.benuta_form_new)
    .filter((item) => item)
  related?.unshift(product?.benuta_form_new)
  return Array.from(new Set(related?.map((item) => item?.toString()))) as string[]
}
